// @flow

import React from "react";
import { SchemaForm } from "@components";
import uiSchema from "./__ui__/schema";
import type { MedicalHistoryItem } from "@modules/employee/reducer/medical-details/types";

type OwnProps = $Exact<{
  data: MedicalHistoryItem | null,
  schema: Object | null,
  onSubmit: (data: MedicalHistoryItem) => void,
}>;

type Props = OwnProps;

export class MedicalHistoryForm extends React.Component<Props> {
  form: *;

  render() {
    return (
      <SchemaForm
        ref={this.formRef}
        className="w-100"
        formData={this.props.data || {}}
        schema={this.props.schema || {}}
        onSubmit={this.props.onSubmit}
        uiSchema={uiSchema}
        noValidate={true}
        externalSubmit
      />
    );
  }
}

export default MedicalHistoryForm;
